import React from 'react';
import CircleIcon from '@tmap/mmm-style-guide/src/CircleIcon';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const IconContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[100],
  borderRadius: '8px',
}));

const StyledCircleIcon = styled(CircleIcon)(() => ({
  display: 'block',
  fontSize: '32px',
}));

function IconWithLabel(props) {
  const {
    Icon,
    label,
  } = props;
  return (
    <IconContainer height='100%' width='100%' padding={1}>
      <Grid container spacing={1.5} alignItems='center' justifyContent='center'>
        <Grid item>
          <StyledCircleIcon
            Icon={Icon}
            color='secondary'
            variant='contained'
            shrinkFactor='1 / 2'
          />
        </Grid>
        <Grid item xs>
          <Typography variant='body2' color='textSecondary'>{label}</Typography>
        </Grid>
      </Grid>
    </IconContainer>
  );
}

export default IconWithLabel;
